import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-grid-icon-bar",
  templateUrl: "./grid-icon-bar.component.html",
  styleUrls: ["./grid-icon-bar.component.css"],
})
export class GridIconBarComponent implements OnInit {
  @Input() showCustomize = false;
  @Input() showCustomizeIncView = false;
  @Input() showFilter = true;
  @Input() showRefresh = true;
  @Input() showSearch = false;
  @Input() showExpandRetract = false;
  @Input() showMetrics = false;
  @Output() customizeEvent = new EventEmitter();
  @Output() customizeIncViewEvent = new EventEmitter();
  @Output() refreshEvent = new EventEmitter();
  @Output() searchIncEvent = new EventEmitter();
  @Output() filterEvent = new EventEmitter();
  @Output() expandRetractEvent = new EventEmitter();
  @Output() metricsEvent = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  customize() {
    this.customizeEvent.emit();
  }
  customizeIncView() {
    this.customizeIncViewEvent.emit();
  }
  refresh() {
    this.refreshEvent.emit();
  }
  clear() {
    this.filterEvent.emit();
  }
  expandRetract() {
    this.expandRetractEvent.emit();
  }
  openMetrics() {
    this.metricsEvent.emit();
  }
  searchInc() {
    this.searchIncEvent.emit();
  }
}
